import styled from 'astroturf/react'
import _Panel from "styles-Panel.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/meeting_package_canceled/styles.js?styleId=Panel";
import _Description from "styles-Description.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/meeting_package_canceled/styles.js?styleId=Description";


const Panel = /*#__PURE__*/styled('div', null, {
  displayName: "Panel",
  styles: _Panel
})

const Description = /*#__PURE__*/styled('p', null, {
  displayName: "Description",
  styles: _Description
})

export { Panel, Description }
